<header class="header" role="banner">
    <h1 class="logo">
        <a class="navbar-brand" routerLink="/"><img src="assets/imgs/logo.png" style="width: 100px;"></a>
    </h1>
    <div class="nav-wrap">
      <nav class="main-nav" role="navigation">
        <ul class="unstyled list-hover-slide">
          <li><a routerLink="/menus-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">قوائم الطعام</a></li>
          <li><a routerLink="/users-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">المستخدمين</a></li>
          <li><a routerLink="/reviews-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">المرجعات</a></li>
          <li><a routerLink="/carousel-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">اللوحات المتحركة</a></li>
          <li><a routerLink="/gallery-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">الأستديو</a></li>
          <li><a routerLink="/crew-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">الطاقم</a></li>
          <li><a routerLink="/contact-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">التواصل</a></li>
          <li><a routerLink="/about-panel" routerLinkActive="exactX" [routerLinkActiveOptions]="{exact:true}">عنا</a></li>
        </ul>
      </nav>
    </div>
  </header>